import { useState, useRef, useEffect } from 'react'

export const usePrevious = value => {
  const ref = useRef()

  useEffect(() => {
    ref.current = value
  }, [value])

  return ref.current
}

// A `position: sticky` element gives no event when it pins. Insetting the observer root by 1px at
// the top makes the pinned element cross under it, which is the only cross-browser signal there is
// -- `scroll-state()` container queries are Chromium-only.
export const useStuckToTop = () => {
  const [node, setNode] = useState(null)
  const [isStuck, setIsStuck] = useState(false)

  useEffect(() => {
    if (null == node || !('IntersectionObserver' in window)) return

    const observer = new window.IntersectionObserver(
      ([entry]) => {
        // a compare-items report fires this with no rect at all; a header nothing can be measured
        // against is not stuck, and reading through the absent rect threw where it used to say so
        const rect = entry?.boundingClientRect
        setIsStuck(Boolean(rect) && 0 < rect.height && 0 >= rect.top)
      },
      { threshold: [1], rootMargin: '-1px 0px 0px 0px' }
    )

    observer.observe(node)

    return () => observer.disconnect()
  }, [node])

  return [isStuck, setNode]
}
